import { cn } from "../../../../helpers/utils";
import ToggleSwitch from "./ToggleSwitch";

export default function ToggleSwitchWithLabel({
  label,
  checked,
  onChange,
  disabled,
  className,
  labelClassName,
  switchClassName,
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-2 w-min-[127px]",
        className
      )}
    >
      <label
        className={cn(
          "select-none cursor-pointer whitespace-nowrap",
          "font-league font-normal text-[14px] leading-[1] tracking-normal",
          labelClassName
        )}
        onClick={(e) => {
          if (typeof onChange === "function") {
            onChange(e.target.checked);
          }
        }}
      >
        {label}
      </label>
      <ToggleSwitch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={switchClassName}
      />
    </div>
  );
}
